import {MatchingLocationType} from '../../../../../service/matching/matching-types';

export function isLocation(fieldValue: string | MatchingLocationType | undefined): fieldValue is MatchingLocationType {
    return Boolean(fieldValue && (fieldValue as MatchingLocationType).id);
}

export function getMatchingCompanyId(field: string): number {
    return Number(field.slice('company_'.length));
}
